import React, { useEffect } from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useTranslation } from "hooks";
import { translations } from "./translations";
import {
  PaginatePermissionsState,
} from "store/ducks/settings/permissions";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridPermissions, FilterPermissions } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListPermissions: React.FC = () => {
  const { getTranslation } = useTranslation(translations);

  const { getData } = useFilters('permissions');

  const { loading, pagination, data } = useSelector<
    RootStateOrAny,
    PaginatePermissionsState
  >((state) => state.paginatePermissions);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")} <MenuSelector page="permissions" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          <FilterPermissions />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridPermissions permissions={data}  loading={loading}/>
        <Paginator
          pagination={pagination}
          settingsPage='permissions'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
